export default "__VITE_ASSET__e9RF1Jki__"